/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState } from "react";
import "../adminCard.css";
import { Modal } from "react-bootstrap";

const ChefProfileDescPopup = ({ data, show, updateChefDescUpload, handleDismiss }) => {
  const [chefDesc, setChefDesc] = useState(data.profileDescription || "");

  const handleDescriptionChange = (e) => {
    setChefDesc(e.target.value);
  };

  const handleClose = () => {
    handleDismiss();
  };

  return (
    <Modal size="lg" show={show} backdrop="static">
      <Modal.Header>
        <Modal.Title>Add Chef Profile Description</Modal.Title>
        <span onClick={handleClose} style={{ cursor: "pointer" }}>&#10006;</span>
      </Modal.Header>
      <Modal.Body>
        <div className="form-group">
          <label htmlFor="chefDesc">Profile Description</label>
          <textarea
            id="chefDesc"
            className="form-control"
            rows="4"
            value={chefDesc}
            onChange={handleDescriptionChange}
            placeholder="Enter chef profile description..."
          ></textarea>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-primary"
          onClick={() => updateChefDescUpload(chefDesc)}
          disabled={!chefDesc.trim()}
        >
          Update
        </button>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={handleClose}
        >
          Close
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ChefProfileDescPopup;
